import { useAuth } from '@clerk/clerk-react';
import { integrationsClient } from './integrations.client';
export const useSlackClient = () => {
    const { getToken } = useAuth();
    const client = async () => integrationsClient(getToken, '/api/slack');
    // Get Slack install URL
    const getInstallUrl = async () => {
        try {
            const apiClient = await client();
            return await apiClient.get('/install');
        }
        catch (error) {
            console.error('Error getting Slack install URL:', error);
            throw error;
        }
    };
    // Get current Slack integrations
    const getIntegrations = async () => {
        try {
            const apiClient = await client();
            return await apiClient.get('/integrations');
        }
        catch (error) {
            console.error('Error fetching Slack integrations:', error);
            throw error;
        }
    };
    // Connect current user to Slack
    const connectUser = async (data) => {
        try {
            const apiClient = await client();
            return await apiClient.post('/connect-user', data);
        }
        catch (error) {
            console.error('Error connecting user to Slack:', error);
            throw error;
        }
    };
    // Get current user's Slack connections
    const getUserConnections = async () => {
        try {
            const apiClient = await client();
            return await apiClient.get('/user-connections');
        }
        catch (error) {
            console.error('Error fetching user Slack connections:', error);
            throw error;
        }
    };
    // Disconnect Slack integration
    const disconnectIntegration = async (teamId) => {
        try {
            const apiClient = await client();
            return await apiClient.delete(`/integrations/${teamId}`);
        }
        catch (error) {
            console.error('Error disconnecting Slack integration:', error);
            throw error;
        }
    };
    return {
        getInstallUrl,
        getIntegrations,
        connectUser,
        getUserConnections,
        disconnectIntegration,
    };
};
